import { studentAlertKey } from "../helper/constants";
import { getApi } from "./apiBase";
import { student_alert } from "./apiURL";


class StudentalertService {
    constructor() {
        this.academicAlerts=[];
        this.studentAlert=[];
        this.alertsData=[];
        this.businessAlerts=[];
        this.ferpaWarnings=[];
    }

    checkAlertFlag(studentId) {
        return sessionStorage.getItem(studentAlertKey) === String(studentId);
    }

    setAlertFlag(studentId) {
        sessionStorage.setItem(studentAlertKey, String(studentId));
    }

    clearAlertFlag() {
        sessionStorage.removeItem(studentAlertKey);
    }

    getAlerts(selectedStudent) {

        // Guard against a null/undefined selection — nothing to look up.
        if (!selectedStudent || selectedStudent.studentID == null) {
            return Promise.resolve({ open: false });
        }

        // Clean the stored flag when switching to a different student.
        // Only clears if a flag exists AND it belongs to another student —
        // re-selecting the same student keeps the flag so the alert is not re-shown.
        const flaggedStudentId = sessionStorage.getItem(studentAlertKey);
        if (flaggedStudentId !== null && flaggedStudentId !== String(selectedStudent.studentID)) {
            this.clearAlertFlag();
        }

        if(!this.checkAlertFlag(selectedStudent.studentID)) {
            return getApi(`${student_alert}/${selectedStudent.studentUID}`).then((resp) => {
                const canViewStudent = this.setAlertsData(resp.data.data);
                // Flag is set only when user clicks OK in AlertsModal.saveAlert(),
                // NOT here — otherwise Cancel/Close also suppresses the modal.
                if ( canViewStudent) {
                    return{
                        alertsData: this.alertsData,
                        open: true,
                        studentName: this.studentAlert[0]["firstName"] ? this.studentAlert[0]["lastName"] + ", " + this.studentAlert[0]["firstName"] : "",
                    }
                }
                return{
                    open: false,
                }
            }).catch((err) => {
                console.log(err);
                return new Promise(resolve => {
                    resolve({
                        open: false
                    })
                });
            })
        } else {
            return new Promise(resolve => {
                resolve({
                    open: false
                })
            });
        }
    }

    setAlertsData(alertsData) {
        this.academicAlerts = alertsData.academicAlerts;
        this.studentAlert = alertsData.studentAlert;
        this.alertsData = alertsData;
        this.businessAlerts = alertsData.businessAlerts;
        this.ferpaWarnings = alertsData.ferpaWarnings;
        if (this.academicAlerts.length > 0 || this.businessAlerts.length > 0 || this.ferpaWarnings.length > 0)
            return true;
        else
            return false;
    }
}

export default new StudentalertService();
